import React from 'react';
import PageGenerator from 'components/generator-shared';
import Loading from 'shared/loading';
import useWordpress from 'hooks/useWordpress';
import Meta from 'shared/meta';

import 'styles/main.scss';

export default function PageTemplate({ pageContext }) {
  const context = process.env.GATSBY_DEVELOPMENT
    ? useWordpress(pageContext)
    : pageContext;
     return context ? (
       <main>
         <Meta {...context?.meta} />
         <PageGenerator {...context} />
       </main>
  ) : (
    <Loading />
  );
}
